// Presentation only, matching Portal/CMS. The form schema still owns validation.
function removeStar(el) {
  el.__reqStarEl?.remove();
  el.__reqStarEl = null;
}

function attachStar(el, binding) {
  if (binding.value === false) {
    removeStar(el);
    return;
  }

  let options = {};
  if (binding.value && typeof binding.value === 'object') {
    options = binding.value;
  }
  if (!el.__reqStarEl) {
    const star = document.createElement('span');
    star.className = 'v-required-star';
    star.setAttribute('aria-hidden', 'true');
    el.__reqStarEl = star;
  }

  const star = el.__reqStarEl;
  const char = options.char ?? '*';
  star.style.color = options.color ?? 'var(--destructive)';
  if (options.position === 'before') {
    star.textContent = char + ' ';
    el.prepend(star);
  } else {
    star.textContent = ' ' + char;
    el.appendChild(star);
  }
}

export default {
  mounted: attachStar,
  updated: attachStar,
  unmounted: removeStar,
};
